import React from "react"

const Loading = () => {
  return (
    <span style={{ position: 'fixed', top: '0', left: '0', bottom: '0', right: '0', zIndex: '9999' }} className="loading-animation"></span>
  )
}

export default Loading